/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetPermissionSecurityGroupRequest
 */
export interface SetPermissionSecurityGroupRequest {
    /**
     * 
     * @type {string}
     * @memberof SetPermissionSecurityGroupRequest
     */
    securityGroupId?: string | null;
}

/**
 * Check if a given object implements the SetPermissionSecurityGroupRequest interface.
 */
export function instanceOfSetPermissionSecurityGroupRequest(value: object): value is SetPermissionSecurityGroupRequest {
    return true;
}

export function SetPermissionSecurityGroupRequestFromJSON(json: any): SetPermissionSecurityGroupRequest {
    return SetPermissionSecurityGroupRequestFromJSONTyped(json, false);
}

export function SetPermissionSecurityGroupRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetPermissionSecurityGroupRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'securityGroupId': json['securityGroupId'] === undefined ? undefined : json['securityGroupId'] === null ? null : json['securityGroupId'],
    };
}

export function SetPermissionSecurityGroupRequestToJSON(json: any): SetPermissionSecurityGroupRequest {
    return SetPermissionSecurityGroupRequestToJSONTyped(json, false);
}

export function SetPermissionSecurityGroupRequestToJSONTyped(value?: SetPermissionSecurityGroupRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'securityGroupId': value['securityGroupId'],
    };
}

